<template>
  <div>
    <v-row>
      <template v-if="!sslDetailsLoaded">
        <v-col cols="12" sm="4">
          <gg-loading :loading="true" type="card"></gg-loading>
        </v-col>
        <v-col cols="12" sm="4">
          <gg-loading :loading="true" type="card"></gg-loading>
        </v-col>
        <v-col cols="12" sm="4">
          <gg-loading :loading="true" type="card"></gg-loading>
        </v-col>
        <v-col cols="12">
          <gg-loading :loading="true" type="table"></gg-loading>
        </v-col>
      </template>
    </v-row>
    <v-row v-if="certificateIssued">
      <template v-if="isAlphaSSL">
        <v-col cols="12" sm="4">
          <site-seal></site-seal>
        </v-col>
        <v-col cols="12" sm="4">
          <warranty></warranty>
        </v-col>
      </template>
      <v-col cols="12" sm="4">
        <download-certificate></download-certificate>
      </v-col>
      <v-col cols="12">
        <installation-status :id="id"></installation-status>
      </v-col>
    </v-row>
    <v-row v-else-if="ssl">
      <v-col cols="12">
        <ssl-auto-installer :id="id"></ssl-auto-installer>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SiteSeal from '@/components/Ssl/SiteSeal'
import Warranty from '@/components/Ssl/Warranty'
import DownloadCertificate from '@/components/Ssl/DownloadCertificate'
import InstallationStatus from '@/components/Ssl/InstallationStatus'
import SslAutoInstaller from '@/components/Ssl/SslAutoInstaller'

export default {
  name: 'SslOverview',
  components: {
    SiteSeal,
    Warranty,
    DownloadCertificate,
    InstallationStatus,
    SslAutoInstaller,
  },
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      sslDetailsLoaded: false,
    }
  },
  computed: {
    ...mapGetters(['ssl_error', 'ssl', 'ssl_status', 'ssl_installs', 'ssls']),
    certificateIssued () {
      return this.ssl_status === 'Certificate Issued'
    },
    isAlphaSSL () {
      return !!this.ssl?.globalsign
    },
    selectedSsl: {
      get () {
        return this.id
      },
      set (id) {
        this.$router.push({ path: `/ssl/${id}` })
      }
    },
  },
  methods: {
    ...mapActions(['sslclearerror', 'ssldostep', 'installSsl', 'uninstallSsl', 'getSslInstalls', 'getSslDetail', 'reportError']),
    async loadDetails () {
      this.sslDetailsLoaded = false
      try {
        await this.getSslDetail(this.id)
      } catch (e) {
        this.reportError(e)
      } finally {
        this.sslDetailsLoaded = true
      }
    },
  },
  watch: {
    id () {
      this.loadDetails()
    },
    ssl () {
      if (this.ssl_status === 'Certificate Issued') {
        this.getSslInstalls(this.id)
      }
    },
  },
  created () {
    this.loadDetails()
  },
}
</script>
